/**
 * Cutting prose a person will read, at a sentence.
 *
 * Shared because both sides cut plan prose to a cap and must cut it the same
 * way: the planner's summary, test strategy and step cases on the server
 * (`builder/planProse.ts`), and a @yagni reply staged as a plan answer in the
 * client (`lib/planAnswerBridge.ts`). Two copies of this drift the first time
 * one of them is fixed.
 */
/**
 * A sentence end: terminal punctuation (optionally closed by a quote or
 * bracket) followed by a line break, or by a space and something that starts
 * a sentence. "e.g. the" and "index.ts" are not ends.
 */
const SENTENCE_END = /[.?!]["')\]]?(?=\s*\n|\s+[A-Z`\d])/g;
/**
 * Whole sentences up to `max`, else a word-boundary cut with an ellipsis. A
 * cut mid-word reads as a rendering failure. Line breaks are kept: the text
 * can be markdown.
 */
export function clipAtSentence(text, max) {
    if (text.length <= max)
        return text;
    const head = text.slice(0, max);
    let end = -1;
    for (const match of head.matchAll(SENTENCE_END))
        end = match.index + match[0].length;
    if (end > 0)
        return head.slice(0, end);
    return clipAtWord(text, max + 1);
}
/**
 * At most `max` characters, cut at the last word boundary with an ellipsis
 * when the text is longer. For text a person reads where whole sentences are
 * not the point (a reply's reason, a finding on a pull request).
 */
export function clipAtWord(text, max) {
    if (text.length <= max)
        return text;
    const head = text.slice(0, max - 1);
    const space = head.search(/\s\S*$/);
    return `${(space > 0 ? head.slice(0, space) : head).replace(/[,;:]$/, "")}…`;
}
//# sourceMappingURL=clipAtSentence.js.map